export default __webpack_public_path__ + "b50a5118e9667c474cfad2b742a63c31.gif";